import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { SimulationProgress } from '../../../../models/results/sim-progress/simulation-progress.model';
import { ProgressService } from '../../../progress.service';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-sens-sim-details',
  templateUrl: './sens-sim-details-dialog.component.html',
  styleUrls: ['./sens-sim-details-dialog.component.scss']
})
export class SensSimDetailsDialogComponent extends UserpilotReloader implements OnInit, OnDestroy {
  simProgress?: SimulationProgress;
  onDestroyNotifier = new Subject<boolean>();

  constructor(
    private simProgressService: ProgressService,
    private dialogRef: MatDialogRef<SensSimDetailsDialogComponent>,
  ) {
    super();
  }

  ngOnInit() {
    this.simProgressService.progressNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(simProgress => {
        if (simProgress) {
          this.simProgress = simProgress;
        }
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.next(true);
    this.onDestroyNotifier.unsubscribe();
  }

  toNumWithCommas(num: number) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  close() {
    this.dialogRef.close(false);
  }

  reSimulate() {
    this.dialogRef.close(true);
  }
}
